import { YBackGroundImage } from "@/utils/style-methods";
import { Component } from "react";
import { isDuApp } from "@/utils/appUtils/getDevice";
import { IBannerConf, IPageColor, IRankList, IUserType } from "../typing";

import appInstall from "@/utils/appUtils/appInstall";
import classnames from 'classnames';
import Lazyload from 'react-lazyload';
import style from '../index.module.less'
import Rank from './rank';
import Jockeys from "@/utils/jockey";
import { imgResource } from "../config/resource";
import { withReactTrack } from "@du/analytics-sdk";
import { createTrackConfig } from '../config/track-config';
interface IBannerAndRankProps {
    bannerList: IBannerConf[];
    renderUserType: IUserType;
    lang: string;
    region: string
    sellerTitleImg: string;
    sellerTitleText: string;
    pageColor: IPageColor;
    rankList: IRankList[]
}
@withReactTrack({ createTrackConfig })
export default class BannerAndRank extends Component<IBannerAndRankProps> {
    constructor(props) {
        super(props);
    }
    
    componentDidMount() {}

    goToDetail(url) {
        // 判断地址是不是http地址，如果是的话走路由，如果不是的话走原生
        let regex = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/i;
        const bool = regex.test(url)

        if (isDuApp()) {
            if (bool) {
                Jockeys.openNativePage('/web/browser', { url: encodeURIComponent(url) });
            } else {
                Jockeys.openNativePage(url)
            }
        } else {
            if (bool) {
                Jockeys.openNativePage('/web/browser', { url: encodeURIComponent(url) });
            } else {
                Jockeys.openNativePage(url)
            }
        }
    }

    renderTitlemap() {
        const { sellerTitleImg, sellerTitleText } = this.props

        if (sellerTitleImg) {
            const sellerTitleBack = YBackGroundImage(sellerTitleImg, [{
                mode: 'resize',
                width: 3* 375,
            }])
            return (
                <div className={style['seller-title']} style={sellerTitleBack} />
            )
        }

        const defaultImg = 'https://cdn.poizon.com/node-common/9026821ac82920b3eebd77a516aa57f4.png';

        const defaultImgBack = YBackGroundImage(defaultImg, [{
            mode: 'resize',
            width: 3 * 117,
        }])

        return (
            <div className={style['seller-title']}>
                <div className={style['seller-title-text']}>{sellerTitleText}</div>
                <div className={style['seller-title-back']} style={defaultImgBack}></div>
            </div>
        )
    }

    renderSellerBanner() {
        const { bannerList } = this.props;
        const bannerData = bannerList
                            .filter(banner => {
                                return +banner.type === IUserType.seller;
                            })
                            .map((banner, index)=> {
                                const imgSrc = YBackGroundImage(banner.img, [{
                                    mode: 'resize',
                                    width: 359 * 3,
                                }]);
                                
                                return (
                                    <div
                                        data-track-exposure={'poizon_trade_block_content_exposure'}
                                        data-track-click={'poizon_trade_block_content_click'}
                                        key = {banner.img + index}
                                        className={style['seller-banner']}
                                        style={{ ...imgSrc }}
                                        data-url={banner.url}
                                        data-block={91}
                                        onClick={()=> this.goToDetail(banner.url)}
                                    ></div>
                                );
                            });
        
        return (
            <div>
                {this.renderTitlemap()}
                {bannerData}
            </div>
        )
    }

    renderBuyerBanner() {
        const { bannerList } = this.props;
        return bannerList
                .filter(banner => {
                    return +banner.type === IUserType.buyer;
                })
                .map((banner, index)=> {
                    const imgSrc = YBackGroundImage(banner.img, [{
                        mode: 'resize',
                        width: 359 * 3,
                    }]);
                    
                    return (
                        <div
                            data-track-exposure={'poizon_trade_block_content_exposure'}
                            data-track-click={'poizon_trade_block_content_click'}
                            key = {banner.img + index}
                            className={style['buyer-banner']}
                            style={{ ...imgSrc }}
                            data-url={banner.url}
                            data-block={1584}
                            onClick={()=> this.goToDetail(banner.url)}
                        ></div>
                    )
                });
    }

    render() {
        const { renderUserType, lang, region, pageColor } = this.props;
        const buyerBanner = this.renderBuyerBanner();
        const sellerBanner = this.renderSellerBanner();
        const footerImage = YBackGroundImage(imgResource["footer-back"], [{
            mode: 'resize',
            width: 2 * 175,
        }]);
        
        return (
            <div className={style['rank-banner-warpper']}>
                {
                    renderUserType === IUserType.buyer
                    ? (
                        <div
                            className={classnames([{
                                [style['banner-warpper']]: true,
                                [style['mask-buyer']]: true,
                            }])}
                            style={{ background: pageColor.couponBackColor }}
                        >
                            <Lazyload once>
                                <div className={style['banner-box']}>
                                    {buyerBanner[0]}
                                    {buyerBanner[1]}
                                </div>
                            </Lazyload>
                            <div className={`${style['banner-box']} ${style['banner-with-rank']}`}>
                                <div className={style['rank-box']}>
                                    <Rank
                                        language={lang}
                                        countryCode={region}
                                        rankList={this.props.rankList}
                                    />
                                </div>
                                <div className={style['banner-more-tall']}>
                                    {buyerBanner[2]}
                                    {buyerBanner[3]}
                                </div>
                            </div>
                        </div>
                    ): (
                        <div
                            className={`${style['banner-warpper']} ${style['mask-seller']}`}
                            style={{ background: pageColor.couponBackColor }}
                        >
                            <div className={`${style['warpper-dashed']}`}></div>
                        </div>
                    )
                }
                {/* 为了做向上的偏移，拉散模块 */}
                <div className={style['footer-img-warpper']}>
                    <div className={style['footer-img']} style={{...footerImage }}></div>
                </div>
                { renderUserType === IUserType.seller ? sellerBanner : (<></>) }
            </div>
        )
    }
}